/* 布局 */
//前台
import Layout from "@views/layout";

const userpermissionmoduleRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "userpermissionmodule",
            name: "USERPERMISSIONMODULE",
            meta: {
                title: "模块管理",
                sort: 1,
            },
            component: () => import("@views/business/userpermissionmodule/index.vue"),
            redirect: {
                name: "USERPERMISSIONMODULE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "USERPERMISSIONMODULE_LIST",
                    meta: {
                        title: "模块管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/userpermissionmodule/list.vue"),
                },
                                {
                    path: "add",
                    name: "USERPERMISSIONMODULE_ADD",
                    meta: {
                        title: "新增授权模块管理",
                        parentPath: '/business/userpermissionmodule/list',
                        operate: true,
                    },
                    component: () => import("@views/business/userpermissionmodule/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "USERPERMISSIONMODULE_EDIT",
                    meta: {
                        title: "编辑授权模块管理",
                        parentPath: '/business/userpermissionmodule/list',
                        operate: true,
                    },
                    component: () => import("@views/business/userpermissionmodule/form.vue"),
                },
                                        ],
    },


        ],
};

export default userpermissionmoduleRouter;
